/* global config:true */
/* eslint-disable no-process-env, eqeqeq, no-eq-null */

const merge = require('lodash.merge');
const defaultFeedbackApiMock = config.feedbackApi.mocks;
let mockEnv = null;

// read in enable mock
if (/^(?:y|yes|true|1|on)$/i.test(process.env.REACT_APP_TODO_MOCKS)) {
	mockEnv = true;
}
if (/^(?:n|no|false|0|off)$/i.test(process.env.REACT_APP_TODO_MOCKS)) {
	mockEnv = false;
}

const mockConfig = {
	feedbackApi: {
		// either use the .env mock or default to config
		mocks: !(mockEnv == null) ? mockEnv : defaultFeedbackApiMock,
	},
};

const customConfig = merge(config, mockConfig);

module.exports = customConfig;
